import React, { memo, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetchVehicles from '../../hooks/vehicles/useFetchVehicles';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import VehiclesTable from './VehiclesTable';

const VehiclesList = () => {
  const navigate = useNavigate();
  const { loading, vehicles } = useFetchVehicles();

  const handleVehicleClick = (vin) => {
    navigate(`/vehicles/${vin}`);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        <VehiclesTable onVehicleClick={handleVehicleClick} vehicles={vehicles} loading={loading} />
        {vehicles.length === 0 && !loading && <EmptyContent title={'Список автомобілів порожній'} />}
      </div>
    </Suspense>
  );
};

export default memo(VehiclesList);
